import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import camelCase from 'lodash/camelCase';
import startCase from 'lodash/startCase';
export const defaultIssueCategories = _ref => {
  let {
    isDefaultLanguage
  } = _ref;
  const categories = [];
  if (!isDefaultLanguage) {
    categories.push({
      key: 'translation-incorrect',
      value: 'There is an issue with the translation'
    });
  }
  categories.push({
    key: 'other',
    value: 'Other'
  });
  return categories;
};
const getI18nKey = (prefix, key) => {
  return "".concat(prefix, ".").concat(camelCase(key), "Label");
};
export const localizeIssueCategories = (i18next, prefix, categories) => categories.map(category => _objectSpread(_objectSpread({}, category), {}, {
  label: category.key === 'other' ? startCase(i18next.t('other', {
    ns: 'common'
  })) : i18next.t(getI18nKey(prefix, category.key))
}));